//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'marketing-page',
  head() {
    return {
      title: 'Procurement Software for Electronics Manufacturing | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Automate your electronics procurement workflow. Generate purchase orders, track supplier quotes and manage component sourcing — all integrated with your BOM and inventory.'
        }
      ]
    };
  }
};
